<template>
  <div style="background: #F9F9FA;">
    <div class="content-box proceduring-banner">
      <div class="content-detail">
        <p class="title">过程化教学</p>
        <p class="text">针对不同场景量身定制系统</p>
        <p class="text">让影像融入临床  让考核融入教学</p>
        <button class="btn">查看详情</button>
      </div>
    </div>
    <div class="content-box tabs-content">
      <div class="content-detail">
        <ul class="tabs">
          <li class="li" :class="{'active': tabIndex === item.id}" v-for="(item, index) in tabList" :key="index" @click="tabClick(item)">{{item.name}}</li>
        </ul>
      </div>
    </div>
    <div class="content-box hospital-content">
      <div class="content-detail">
        <ul class="hospital-list">
          <li class="li" :class="{'margin24': (index + 1) % 3 !== 0}" v-for="(item, index) in hospitalList" :key="index">
            <a :href="item.url?item.url:'javascript:;'" :target="item.url?'_blank':''">
              <img class="img" :src="`${item.imgUrl}`"/>
              <p class="title"><span class="margin">{{item.title}}</span><span v-if="item.type" class="level" :class="{'color1': item.type === 1}">{{item.type === 1 ? '学校' : '医院'}}</span></p>
              <p class="info" v-html="item.content"></p>
            </a>
          </li>
        </ul>
        <div class="more" v-show="hospitalList.length < allHospitalList.length">
          <button @click="getMore">了解更多<i class="el-icon-arrow-right i1"></i><i class="el-icon-arrow-right i2"></i><i class="el-icon-arrow-right i3"></i></button>
        </div>
      </div>
    </div>
    <div class="empty" v-show="!allHospitalList.length">
      <img src="/static/img/empty.png">
      <p>没有更多了~</p>
    </div>
  </div>
</template>

<script>
import { officialSiteServer } from '@/api/api'
import getImgUrl from '@/mixin/getImgUrl.js'
export default {
  mixins: [getImgUrl],
  name: 'proceduring',
  data () {
    return {
      tabList: [
        { name: '全部', id: '' },
        { name: '学校', id: '1' },
        { name: '医院', id: '2' }
      ],
      tabIndex: '',
      hospitalList: [],
      allHospitalList: [],
      hospitalIndex: 0
    }
  },
  beforeDestroy () {
  },
  mounted () {
    this.readDetail()
  },
  methods: {
    tabClick (item) {
      if (this.tabIndex === item.id) return
      this.tabIndex = item.id
      this.readDetail()
    },
    readDetail () {
      this.allHospitalList = []
      this.hospitalList = []
      officialSiteServer.queryRotate({
        type: this.tabIndex
      }).then((res) => {
        let { code, data } = res
        if (code === '0') {
          this.allHospitalList = data
          this.getImgUrl(this.allHospitalList, 'img')
          this.hospitalList = data.slice(0, 6)
          this.hospitalIndex = 3
        }
      })
    },
    getMore () {
      if (this.allHospitalList.length > this.hospitalList.length) {
        this.hospitalIndex += 6
        if (this.allHospitalList.length > this.hospitalIndex) {
          this.hospitalList = this.allHospitalList.slice(0, this.hospitalIndex)
        } else {
          this.hospitalList = this.allHospitalList
        }
      }
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
@import "~less-lib";
@media (min-width: 1920px) {
  .proceduring-banner{
    background: url("/static/img/applications/proceduring.png") no-repeat;
  }
}
@media (max-width: 1920px) {
  .proceduring-banner{
    background: url("/static/img/applications/proceduring1.jpg") no-repeat;
  }
}
.proceduring-banner {
  height: 560px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .content-detail {
    height: 560px;
    padding-top: 102px;
    text-align: left;
  }
  .title {
    font-family: AlibabaPuHuiTi-Medium;
    font-size: 80px;
    line-height: 110px;
    color: #FFFFFF;
    letter-spacing: 7.11px;
    margin-bottom: 26px;
  }
  .text {
    font-family: AlibabaPuHuiTi-Regular;
    font-size: 30px;
    line-height: 42px;
    color: #FFFFFF;
    letter-spacing: 2.67px;
    font-weight: 400;
  }
  .btn {
    width: 126px;
    height: 46px;
    line-height: 46px;
    background: #0C59EF;
    border-radius: 4px;
    font-family: SourceHanSansSC-Medium;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 1.42px;
    position: absolute;
    left: 0;
    bottom: 120px;
    cursor: pointer;
  }
}
.tabs-content {
  background-color: #fff;
  margin-bottom: 100px;
  .tabs {
    height: 64px;
    text-align: left;
    .li {
      display: inline-block;
      height: 64px;
      line-height: 64px;
      font-family: SourceHanSansSC-Medium;
      font-size: 14px;
      color: #000000;
      border-bottom: 1px solid #fff;
      margin-right: 50px;
      cursor: pointer;
    }
    .active {
      color: #0C59EF;
      border-bottom: 1px solid #0C59EF;
    }
  }
}
.hospital-content {
  .hospital-list {
    text-align: left;
    .li {
      // width: 576px;
      // height: 483px;
      width: 384px;
      height: 464px;
      border-radius: 14px;
      overflow: hidden;
      box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
      margin-bottom: 40px;
      display: inline-block;
      position: relative;
    }
    .margin24 {
      margin-right: 24px;
    }
    .li:nth-child(odd) {
      // margin-right: 48px;
    }
    .img {
      // width: 576px;
      // height: 324px;
      width: 384px;
      height: 216px;
      margin-bottom: 20px;
    }
    .title {
      width: 344px;
      font-family: SourceHanSansSC-Medium;
      font-size: 24px;
      line-height: 33px;
      color: #000000;
      margin-left: 20px;
      margin-bottom: 16px;
      text-align: left;
      span {
        font-family: SourceHanSansSC-Medium;
      }
    }
    .margin {
      margin-right: 24px;
    }
    .level {
      padding: 0 9px;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      border-radius: 4px;
      border: 1px solid #0C59EF;
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      line-height: 22px;
      height: 24px;
      color: #0C59EF;
    }
    .color1 {
      border: 1px solid #E7871E;
      color: #E7871E;
    }
    .info {
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      color: #666666;
      text-align: left;
      padding-left: 22px;
      padding-right: 20px;
    }
  }
  .more {
    padding: 96px 0 120px 0;
    button {
      height: 25px;
      line-height: 25px;
      font-family: SourceHanSansSC-Medium;
      font-size: 18px;
      color: #666666;
      background: none;
      cursor: pointer;
      position: relative;
      width: 105px;
      text-align: left;
    }
    i {
      color: #979797;
      position: absolute;
      top: 3px;
    }
    .i1 {
      right: 14px;
    }
    .i2 {
      opacity: .6;
      right: 7px;
    }
    .i3 {
      opacity: .4;
      right: 0;
    }
    button:hover {
      color: #0C59EF;
      i {
        color: #0C59EF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/applications/proceduring.vue